export default __webpack_public_path__ + "static/media/langicon.5ba218d3.svg";